<template>
  <iframe
    class="responsive-iframe"
    :src="homeDashboard"
    frameborder="0"
    style="border: 0"
    allowfullscreen
  ></iframe>
</template>

<script>
import Vue from "vue";
import { Auth, oAuth } from "../../../classes/Auth";
export default Vue.extend({
  name: "d6",
  props: {
    source: String,
  },
  data: () => ({
    homeDashboard: "",
    auth: new Auth(),
  }),
  mounted() {
    if (this.auth.getProject().name == "DAVIVIENDA") {
      this.homeDashboard ="https://datastudio.google.com/embed/reporting/efe0d0e6-0043-47fd-b5d7-ef7eec097b5e/page/hHWZB"
    }
    if (this.auth.getProject().name == "DAVIVIENDA II") {
      this.homeDashboard = "https://datastudio.google.com/embed/reporting/22662ac6-8606-4e2e-a9b3-f5b33f6ffe05/page/P8g2B"    }
    }
});
</script>


<style>
.container {
  position: relative;
  overflow: hidden;
  width: 100%;
  padding-top: 56.25%; /* 16:9 Aspect Ratio (divide 9 by 16 = 0.5625) */
}

/* Then style the iframe to fit in the container div with full height and width */
.responsive-iframe {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  width: 100%;
  height: 100%;
}
</style>


